import script from "./MdEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./MdEditor.vue?vue&type=script&setup=true&lang=ts"

import "./MdEditor.vue?vue&type=style&index=0&id=3714b708&lang=css"

const __exports__ = script;

export default __exports__